import { memo } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import useAuth from '@/hooks/useAuth';
import PublicLayout from './PublicLayout';

const PublicRoute = memo(function PublicRoute() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  return !isAuthenticated ? (
    <PublicLayout>
      <Outlet />
    </PublicLayout>
  ) : (
    <Navigate to={{ pathname: '/', search: location.search }} />
  );
});

export default PublicRoute;
